import Breadcrumbs from "@/components/Breadcrumbs";
import FlagIcon from "@mui/icons-material/Flag";
import { Box, Button, Card, CardActions, CardContent, Container, Grid, Typography } from "@mui/material";
import { Link as RouterLink, useNavigate, useSearchParams } from "react-router-dom";
import ProjectTemplateCard from "./ProjectTemplateCard";

export default function ProjectTemplateList() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    // old code set query params
    //
    // const navigateWithExtraSearchParams = (template, extraParams = {}) =>
    //     setSearchParams((prev) => {
    //         prev.set("template", template);
    //         Object.entries(extraParams).forEach(([key, value]) => prev.set(key, value));
    //         return prev;
    //     });

    return (
        <>
            <Container>
                <Breadcrumbs items={[{ label: "Projects", to: "/workspace/projects" }, { label: "New" }]} />
            </Container>

            <Container>
                <Typography variant="h1" fontSize={34} fontWeight="bold" gutterBottom sx={{ marginTop: 3 }}>
                    Project template
                </Typography>

                <Grid container spacing={3} alignItems="stretch">
                    <Grid item md={12} lg={6}>
                        <Card variant="outlined">
                            <CardContent>
                                <ProjectTemplateCard
                                    logo={<FlagIcon sx={{ fontSize: 40 }} color="primary" />}
                                    title="Flagship Project"
                                    description="สร้าง Flagship Project โดยเชื่อมโยงกับแผนปฏิบัติการ"
                                />
                            </CardContent>
                            <CardActions>
                                <Button component={RouterLink} to="./flagship">
                                    Create
                                </Button>
                                <Button variant="info" disabled={true}>
                                    Learn more
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: 5,
                    }}
                >
                    how to create new project. <u>manual</u>
                </Box>
            </Container>
        </>
    );
}
